import { TFunction } from 'i18next';
import { convertCamelCaseIntoSnakeCase } from 'helpers';
import { IStatisticTableColumn } from 'modules/admin-panel/models';
import { StatisticGroupingTypes } from 'modules/admin-panel/models/MapInfoModes';

interface IHeaders extends Record<string, string> {
	name: string;
}

export const getConstantStatisticTableColumns = (
	TableHeaders: IHeaders,
	statisticType: StatisticGroupingTypes,
	t: TFunction,
): IStatisticTableColumn[] =>
	Object.keys(TableHeaders).map((name) => ({
		id: name,
		label:
			name === TableHeaders.name
				? t(`titles.${convertCamelCaseIntoSnakeCase(statisticType)}`)
				: t(`titles.${name}`),
		minWidth: name === TableHeaders.name ? 100 : 70,
	}));
